<template>
  <div class="appointment">
    <myDialog :logTitle="'预约调解时间'" :showDialog.sync="open" style="z-index: 999" :log-height="'300px'">
      <el-button type="primary" class="close" icon="el-icon-circle-close" size="medium" @click="close(false)"/>
      <div class="main-content">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="选择日期" prop="appointmentDate">
            <el-date-picker class="datetime-date" v-model="form.appointmentDate" type="date" placeholder="选择预约调解日期"
                            :picker-options="pickerDateOptions" :clearable="false" @change="dateChange()"/>
          </el-form-item>
          <el-form-item label="选择时间" required>
            <el-col :span="11">
              <el-form-item prop="startTime">
                <el-time-select placeholder="起始时间" v-model="form.startTime"
                                :picker-options="startTimeInit()"
                                @focus="showPick"/>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item prop="endTime">
                <el-time-select placeholder="结束时间" v-model="form.endTime"
                                :picker-options="{start: '09:00',step: '00:30',end: '18:00',minTime: form.startTime}"
                                @focus="showPick" :disabled="endTimeDisabled"/>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submit('form')">确认</el-button>
            <el-button @click="close(false)">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
  </div>
</template>

<script>
import myDialog from '@/components/custom/myDialog.vue'
import {booking} from "@/api/mediation/mediation";

export default {
  name: 'AppointmentDate',
  components: {myDialog},
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    recordId: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      form: {
        appointmentDate: new Date(),
        startTime: undefined,
        endTime: undefined,
      },
      pickerDateOptions: {
        disabledDate(time) {
          return time.getTime() <= Date.now() - 8.64e7;
        },
      },
      rules: {
        appointmentDate: [
          {required: true, message: '请选择日期', trigger: 'change'}
        ],
        startTime: [
          {required: true, message: '请选择开始时间', trigger: 'change'}
        ],
        endTime: [
          {required: true, message: '请选择结束时间', trigger: 'change'}
        ],
      },
    }
  },
  watch: {},
  computed: {
    endTimeDisabled() {
      if (this.form.startTime === undefined || this.form.startTime === null) {
        this.form.endTime = undefined;
        return true;
      }
    }
  },
  created() {

  },
  methods: {
    close(refresh) {
      this.$emit('close', {open: false, refresh: refresh});
    },
    showPick() {
      this.$nextTick(() => {
        // 阻止时间选择器滚动时的冒泡事件
        let time1 = document.getElementsByClassName('el-picker-panel')[0];
        let time2 = document.getElementsByClassName('el-picker-panel')[1];

        if (time1 !== undefined) {
          time1.addEventListener('mousewheel', (e) => {
            e.stopPropagation();
          });
        }
        if (time2 !== undefined) {
          time2.addEventListener('mousewheel', (e) => {
            e.stopPropagation();
          });
        }
      });
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let recordId = this.recordId;
          let beginTime = this.parseTime(this.form.appointmentDate, '{y}-{m}-{d}') + ' ' + this.form.startTime + ":00";
          let endTime = this.parseTime(this.form.appointmentDate, '{y}-{m}-{d}') + ' ' + this.form.endTime + ":00";
          let userName = this.$store.getters.userName;
          const params = {recordId, userName, beginTime, endTime};
          booking(params).then(res => {
            if (res.code === 200) {
              this.$message.success("预约成功!");
              this.close(true);
            } else {
              this.$message.error("预约失败!");
            }
          }).catch((err) => {
            this.$message.error("预约失败!");
          });
        } else {
          return false;
        }
      });
    },
    startTimeInit() {
      const result = {
        start: '09:00',
        end: '17:30',
        step: '00:30',
        minTime: '08:30',
      }
      let selectDate = this.parseTime(this.form.appointmentDate, '{y}-{m}-{d}');
      let nowDate = this.parseTime(Date.now(), '{y}-{m}-{d}');
      if (selectDate === nowDate) {
        let customerDate = new Date();
        let curH = customerDate.getHours();
        let curM = customerDate.getMinutes();
        if (curM < 30) {
          result.minTime = curH + ":00";
        } else {
          result.minTime = curH + ":30";
        }
      }
      return result;
    },
    dateChange() {
      this.form.startTime = undefined;
      this.form.endTime = undefined;
    },
  }
}
</script>

<style lang="scss">
.appointment {
  width: 100%;

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: #0F1F46;
  }

  .close:hover {
    background-color: #0F1F46;
  }

  .logContent {
    width: 50%;
  }

  .logMain {
    overflow-y: hidden;
  }

  .main-content {
    color: rgb(177, 227, 255);
    padding-left: 10px;
    padding-right: 10px;

    .line {
      display: inline-block;
      width: 30px;
      text-align: center;
    }
  }
}

</style>>
